import { BlitzPage } from "@blitzjs/next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import Layout from "src/app/core/layouts/Layout"
import { ContactPage } from "../app/website/feature-contact"

const Contact: BlitzPage = () => {
  return <ContactPage />
}

Contact.suppressFirstRenderFlicker = true
Contact.getLayout = (page) => <Layout title="Contact | Foto's Op School">{page}</Layout>

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  }
}

export default Contact
